// Checks for updates and shows notification if new version available

(function() {
  'use strict';

  // Increment this version number when you deploy updates
  const PB_VERSION = '1.0.15';

  
  window.PB_VERSION = PB_VERSION;

  // Version file URL
  const VERSION_FILE_URL = 'https://cdn.shopify.com/s/files/1/0652/8322/7876/files/pb-version.js?v=1775843695';

  let updateShown = false;

  function showUpdateNotification() {
    if (updateShown || document.getElementById('pbUpdateNotification')) return;
    updateShown = true;

    const notification = document.createElement('div');
    notification.id = 'pbUpdateNotification';
    notification.innerHTML = `
      <div style="position: fixed; top: 20px; right: 20px; background: #2d2d2d; color: #ffffff; padding: 24px 28px; border-radius: 12px; box-shadow: 0 8px 32px rgba(0,0,0,0.4); z-index: 99999; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; max-width: 380px; border: 1px solid #444;">
        <div style="font-weight: 600; margin-bottom: 10px; font-size: 18px; color: #c9a55a;">Update Available</div>
        <div style="font-size: 14px; margin-bottom: 18px; color: #ccc; line-height: 1.5;">A new version of Package Builder is available. Please reload to get the latest features.</div>
        <div style="display: flex; gap: 12px;">
          <button onclick="location.reload(true)" style="flex: 1; padding: 12px 18px; background: #c9a55a; color: #1a1a1a; border: none; border-radius: 6px; cursor: pointer; font-weight: 600; font-size: 14px; transition: background 0.2s;" onmouseover="this.style.background='#d4b366'" onmouseout="this.style.background='#c9a55a'">Reload Now</button>
          <button onclick="document.getElementById('pbUpdateNotification').remove()" style="padding: 12px 18px; background: transparent; color: #999; border: 1px solid #555; border-radius: 6px; cursor: pointer; font-size: 14px; transition: all 0.2s;" onmouseover="this.style.borderColor='#888';this.style.color='#fff'" onmouseout="this.style.borderColor='#555';this.style.color='#999'">Later</button>
        </div>
      </div>
    `;
    document.body.appendChild(notification);
  }

  async function checkForUpdates() {
    try {
      // Fetch the version file with a cache-busting parameter
      const response = await fetch(VERSION_FILE_URL + '&t=' + Date.now(), { cache: 'no-store' });
      if (response.ok) {
        const text = await response.text();
        const match = text.match(/PB_LATEST_VERSION\s*=\s*['"]([^'"]+)['"]/);
        if (match && match[1] !== PB_VERSION) {
          showUpdateNotification();
        }
      }
    } catch (e) {
      // Silently fail - version check is not critical
    }
  }

  
  setInterval(checkForUpdates, 30000);

  console.log('Package Builder Version Check loaded (v' + PB_VERSION + ')');
})();